import moment from "moment";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import {
  formatUtcToLocal,
  parseTime,
  parseTimeLocal,
  replaceEmptyWithHyphen,
  valueOrEmpty
} from "../../../../utils/helpers/text";
import { produceValueForItem } from "../../common-for-log-sheet-and-run-logs/table-common-meta-info";
import { getHierarchyQualificationStatus } from "../../helpers/get-hierarchy-qualification-status";
import { entryType } from "../../../../constants";
import DATA_MODEL_TABLE from "../../../../utils/constants/dataModelTable";
import { allLogAttributesTable, allLogHierarchyTable } from "../../../../utils/helpers/changeIndex";
import ReactDOMServer from "react-dom/server";

const getActionQualificationStatus = (item) =>
  item.equipmentDetails?.entryType === entryType.cluster
    ? valueOrEmpty(item.gxpReadyCluster?.value)
    : valueOrEmpty(item.gxpReady?.newValue?.value || item.gxpReady?.value);

const getActionSystemStatus = (item) =>
  item.equipmentDetails?.entryType === entryType.cluster
    ? valueOrEmpty(item.systemStatusCluster?.value)
    : valueOrEmpty(item.systemStatus?.newValue?.value || item.systemStatus?.value);

/**
 * function that maps the objects fetched from the db to csv file fields we export
 * @param {object} items - unprocessed data
 * @returns data for csv export
 */
export const logSheetItemsToSheet = ((items) =>
  items.map((item) => {
    const actionDateTime = item.actionDateTime
      ? formatUtcToLocal(item.actionDateTime)
      : `${valueOrEmpty(item.actionDate, true)} (${valueOrEmpty(parseTime(item.actionTime))})`;
    return {
      "Equipment ID": valueOrEmpty(item?.equipmentId),
      "Action date": actionDateTime,
      "Creation date": item.createdAt ? formatUtcToLocal(item.createdAt) : "-",
      "Action type": item.action?.value,
      "ECR number": item.ecrNumber,
      "Serial number": valueOrEmpty(item.serialNumber),
      "Material number": valueOrEmpty(item.materialNumber),
      Model: valueOrEmpty(item.equipmentModel),
      Description: valueOrEmpty(item.description),
      Signee: valueOrEmpty(item.approverUserName),
      Nickname: valueOrEmpty(item.instrumentDetails?.equipmentNickName || item.equipmentDetails?.equipmentNickName),
      Operator: valueOrEmpty(item.operatorUserName),
      "Intended use GxP relevant": valueOrEmpty(item.equipmentDetails?.gxpRelevant, false, "-"),
      "Qualification status": getActionQualificationStatus(item),
      [DATA_MODEL_TABLE.systemStatus.value]: getActionSystemStatus(item),
      Manufacturer: valueOrEmpty(item.instrumentDetails?.manufacturer || item.equipmentDetails?.manufacturer),
      Site: valueOrEmpty(item.site),
      Location: valueOrEmpty(item.instrumentDetails?.location || item.equipmentDetails?.location),
      "Software version": valueOrEmpty(
        item.instrumentDetails?.softwareVersion || item.equipmentDetails?.softwareVersion
      ),
      "Configuration Baseline": valueOrEmpty(item.logbookConfigurationBaseline?.newValue),
      [DATA_MODEL_TABLE.responsibleProxy.value]: valueOrEmpty(
        item.instrumentDetails?.responsibleProxy || item.equipmentDetails.responsibleProxy
      ),
      [DATA_MODEL_TABLE.responsiblePerson.value]: valueOrEmpty(
        item.instrumentDetails?.responsiblePerson || item.equipmentDetails?.responsiblePerson
      )
    };
  }));

export const ACTION_SHEET_TABLE_HEADERS = [
  { header: ACTION_LOGS_DATA_MODEL.actionDate.value, value: 22 },
  { header: ACTION_LOGS_DATA_MODEL.actionType.value, value: 20 },
  { header: COMMON_LOGS_DATA_MODEL.description.value, value: 28 },
  { header: "Model", value: 20 },
  { header: "Variant", value: 16 },
  { header: "Equipment ID", value: 20 },
  { header: COMMON_LOGS_DATA_MODEL.serialNumber.value, value: 18 },
  { header: COMMON_LOGS_DATA_MODEL.gxpRelevant.value, value: 18 },
  { header: ACTION_LOGS_DATA_MODEL.gxpReady.value, value: 20 },
  { header: ACTION_LOGS_DATA_MODEL.systemStatus.value, value: 20 },
  { header: "Configuration Baseline", value: 20 },
  { header: ACTION_LOGS_DATA_MODEL.ecrNumber.value, value: 18 },
  { header: COMMON_LOGS_DATA_MODEL.approverUserName.value, value: 27 }
];

export const ACTION_LOGS_CENTRIC_TABLE_HEADERS = [
  { header: ACTION_LOGS_DATA_MODEL.actionDate.value, value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.actionType.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.description.value, value: 40 },
  { header: COMMON_LOGS_DATA_MODEL.gxpRelevant.value, value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.gxpReady.value, value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.systemStatus.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.approverUserName.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.operatorUserName.value, value: "auto" },
  { header: "Configuration Baseline", value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.ecrNumber.value, value: "auto" }
];

export const ACTION_HIERARCHY_TABLE_HEADERS = [
  { header: "", value: 1 },
  { header: COMMON_LOGS_DATA_MODEL.equipmentModel.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.location.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.manufacturer.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.equipmentId.value, value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.serialNumber.value, value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.gxpReady.value, value: "auto" },
  { header: ACTION_LOGS_DATA_MODEL.systemStatus.value, value: "auto" },
  { header: DATA_MODEL_TABLE.gxpRelevant.value + "?", value: "auto" },
  { header: COMMON_LOGS_DATA_MODEL.softwareVersion.value, value: "auto" }
];

const parseTimeVariousInputFormats = (time) => {
  const theTime = parseTimeLocal(time);
  if (theTime !== time) {
    return theTime;
  }
};

export const runSheetItemsToPDF = (items, allLogHierarchyData, logBookEquipment, inventoryId, storeGxpReadys) => {
  let records;
  records = items.map((item) => {
    const activityDate = `${moment(item.actionDate).format("DD-MMM-yyyy")}`;
    const activityTime = parseTimeVariousInputFormats(item.actionTime);
    const actionDateTime = item.actionDateTime
      ? formatUtcToLocal(item.actionDateTime)
      : (activityDate + " " + activityTime);
    if (inventoryId) {
      return [
        actionDateTime,
        valueOrEmpty(item.action?.value, false, "-"),
        valueOrEmpty(item.description, false, "-"),
        valueOrEmpty(item.equipmentDetails?.gxpRelevant, false, "-"),
        valueOrEmpty(produceValueForItem(item, "gxpReady").value, false, "-"),
        valueOrEmpty(produceValueForItem(item, "systemStatus").value, false, "-"),
        valueOrEmpty(item.approverUserName, false, "-"),
        valueOrEmpty(item.operatorUserName, false, "-"),
        valueOrEmpty(item.logbookConfigurationBaseline?.newValue, false, "-"),
        valueOrEmpty(item.ecrNumber, false, "-")
      ];
    } else {
      return [
        actionDateTime,
        valueOrEmpty(item.action?.value, false, "-"),
        valueOrEmpty(item.description, false, "-"),
        valueOrEmpty(item.equipmentModel, false, "-"),
        valueOrEmpty(item.equipmentDetails?.variant, false, "-"),
        valueOrEmpty(item.equipmentId, false, "-"),
        valueOrEmpty(item.serialNumber, false, "-"),
        valueOrEmpty(item.equipmentDetails?.gxpRelevant, false, "-"),
        valueOrEmpty(produceValueForItem(item, "gxpReady").value, false, "-"),
        valueOrEmpty(produceValueForItem(item, "systemStatus").value, false, "-"),
        valueOrEmpty(item.logbookConfigurationBaseline?.newValue, false, "-"),
        valueOrEmpty(item.ecrNumber, false, "-"),
        valueOrEmpty(item.approverUserName, false, "-")
      ];
    }
  });
  let hierarchyRecords = null;
  if (
    logBookEquipment?.entryType === entryType.cluster ||
    logBookEquipment?.entryType === entryType?.clusterSubequipment
  ) {
    const allLogItem = allLogHierarchyTable(allLogHierarchyData);
    hierarchyRecords = allLogItem.map((item) => {
      return [
        replaceEmptyWithHyphen(item.clusterParent?.length),
        replaceEmptyWithHyphen(item.equipmentModel),
        replaceEmptyWithHyphen(item.location),
        replaceEmptyWithHyphen(item.manufacturer),
        replaceEmptyWithHyphen(item.equipmentId),
        replaceEmptyWithHyphen(item.serialNumber),
        replaceEmptyWithHyphen(getHierarchyQualificationStatus(item, storeGxpReadys)),
        replaceEmptyWithHyphen(item?.systemStatus),
        item.gxpRelevant === "NOTAVAILABLE" ? "-" : replaceEmptyWithHyphen(item.gxpRelevant),
        replaceEmptyWithHyphen(item.softwareVersion)
      ];
    });
  }

  const allLogAttributesItem = allLogAttributesTable(logBookEquipment);
  const attributes = ReactDOMServer.renderToStaticMarkup(allLogAttributesItem);
  const equipmentEntryType =
    logBookEquipment?.entryType === entryType.cluster || logBookEquipment?.entryType === entryType?.clusterSubequipment;

  return {
    headers: inventoryId ? ACTION_LOGS_CENTRIC_TABLE_HEADERS : ACTION_SHEET_TABLE_HEADERS,
    // hierarchy: hierarchy,
    entryType: equipmentEntryType,
    hierarchyHeaders: ACTION_HIERARCHY_TABLE_HEADERS,
    hierarchyRecords: hierarchyRecords,
    attributes: attributes,
    records: records
  };
};
